<template lang="pug">
	.animation-settings(v-if="showed && animation" v-window)
		.card
			.card-header
				i.fa.fa-edit
				span Animation Settings
			.card-body.collapse.show
				.form-line.separator
					.form-group
						label.col-form-label.controls-title Animation name
						.controls
							input.form-control.title(size="16" type="text" v-model="title" @change="updateName")
					.form-group.duration-scale
						label.col-form-label.controls-title {{Metadata.AnimationPropertiesByCodename['durationScale']['title']}}
						.controls.duration-scale-control
							InputNumberDrag(v-on:change="setAnimationProperty('durationScale', $event)" :default="Metadata.AnimationPropertiesByCodename['durationScale']['default']" :value="animation.props.durationScale" :options="Metadata.AnimationPropertiesByCodename['durationScale']['options']")
					.form-group.repeat
						label.col-form-label.controls-title {{Metadata.AnimationPropertiesByCodename['repeat']['title']}}
						.controls.duration-scale-control
							select.custom-select(v-on:change="setAnimationProperty('repeat', $event.target.value)")
								option(v-for="(value, key) in Metadata.AnimationPropertiesByCodename['repeat']['options']['values']" :value="key" :selected="parseInt(key) === animation.props.repeat") {{value}}
					.form-group.delay
						label.col-form-label.controls-title {{Metadata.AnimationPropertiesByCodename['delay']['title']}}
						.controls.duration-scale-control
							InputNumberDrag(v-on:change="setAnimationProperty('delay', $event)" :default="Metadata.AnimationPropertiesByCodename['delay']['default']" :value="animation.props.delay" :options="Metadata.AnimationPropertiesByCodename['delay']['options']")
				.animation-steps.separator
					.animation-steps-header
						.animation-step-up
						.animation-step-down
						.animation-step-time Start time
						.animation-step-property Property
						.animation-step-value Value
						.animation-step-duration Duration
						.animation-step-ease Ease
						.animation-step-relative Relative
						.animation-step-delete
					.animation-step(v-for="(animationStep, index) in animationSteps" :set="prop = Metadata.ElementPropertiesByCodename[animationStep.property]")
						.animation-step-up
							.fa.fa-caret-up(:class="{disabled: index === 0}" v-on:click="moveUp(animationStep)")
						.animation-step-down
							.fa.fa-caret-down(:class="{disabled: index >= animationSteps.length - 1}" v-on:click="moveDown(animationStep)")
						.animation-step-time
							InputSelect(v-on:change="setTime(animationStep, $event)" :default="0" :value="animationStep.time" :values="times" :options="{}" theme="dark-medium")
						.animation-step-property
							InputSelect(v-on:change="setProperty(animationStep, $event)" :default="null" :value="animationStep.property" :values="properties" :options="{editable: false, displayedValueTransform: v => Metadata.ElementPropertiesByCodename[v]?.title || ''}" theme="dark-medium")
						.animation-step-value(v-if="prop")
							.control-dropdown-asset-image(v-if="prop.options.control === 'EditorPropertyImage'")
								EditorPropertyImage(v-on:change="setValue(animationStep, $event.assetCodename)" :value="animationStep.value" theme="dark-medium")
							.control-dropdown-localization-text(v-if="prop.options.control === 'EditorPropertyText'")
								EditorPropertyText(v-on:change="setValue(animationStep, $event.textCodename)" :value="animationStep.value" theme="dark-medium")
							.control-dropdown-asset-video(v-if="prop.options.control === 'EditorPropertyVideo'")
								EditorPropertyVideo(v-on:change="setValue(animationStep, $event.assetCodename)" :value="animationStep.value" theme="dark-medium")
							.control-dropdown-asset-spine(v-if="prop.options.control === 'EditorPropertySpine'")
								EditorPropertySpine(v-on:change="setValue(animationStep, $event.assetCodename)" :value="animationStep.value" theme="dark-medium")
							.control-dropdown-spine-option(v-if="prop.options.control === 'EditorPropertySpineOption'")
								EditorPropertySpineOption(v-on:change="setValue(animationStep, $event.name)" :value="animationStep.value" :element="element" :list="prop.options.controlOptions?.list" theme="dark-medium")
							.control-range(v-if="prop.options.control === 'InputRange'")
								InputRange(v-on:change="setValue(animationStep, $event)" v-on:input="setValue(animationStep, $event, false)" :default="prop['default']" :value="animationStep.value" :type="prop.type" :options="prop.options" theme="dark-medium")
							.control-number(v-else-if="prop.options.control === 'Select'")
								Select(v-on:change="setValue(animationStep, $event)" :default="prop['default']" :value="animationStep.value" :values="prop['options']['values']" :type="prop.type" theme="dark-medium")
							.control-coords(v-else-if="prop.options.control === 'InputCoordsDrag'")
								InputCoordsDrag(v-on:change="setValue(animationStep, $event)" v-on:input="setValue(animationStep, $event, false)" :default="prop['default']" :value="animationStep.value" :options="prop.options" theme="dark-medium")
							.control-coords(v-else-if="prop.options.control === 'InputNumberDrag'")
								InputNumberDrag(v-on:change="setValue(animationStep, $event)" v-on:input="setValue(animationStep, $event, false)" :default="prop['default']" :value="animationStep.value" :options="prop.options" theme="dark-medium")
							.control-coords(v-else-if="prop.options.control === 'InputAngle'")
								InputAngle(v-on:change="setValue(animationStep, $event)" v-on:input="setValue(animationStep, $event, false)" :default="prop['default']" :value="animationStep.value" :options="prop.options" theme="dark-medium")
							.control-boolean(v-else-if="prop.options.control === 'InputSwitch'")
								InputSwitch(v-on:input="setValue(animationStep, $event)" :default="prop['default']" :value="animationStep.value" :options="prop.options" theme="dark-medium")
						.animation-step-value(v-else)
						.animation-step-duration
							InputNumberDrag(v-on:change="setDuration(animationStep, $event)" :default="0" :value="animationStep.duration" :disabled="!prop?.options?.animate" disabledValue="0" :options="{changes:{min:0,step:0.1,accuracy:2}}" theme="dark-medium")
						.animation-step-ease
							InputSelect(v-on:change="setEase(animationStep, $event)" default="power2.inOut" :value="animationStep.ease" :values="easings" :options="{}" :disabled="animationStep.duration === 0 || !prop?.options?.animate" disabledValue="none" theme="dark-medium")
						.animation-step-relative
							InputSwitch(v-on:input="setRelative(animationStep, $event)" :default="false" :value="!!animation.options?.relative?.[animationStep.property]" :disabled="!prop?.options?.animate" :options="{}" theme="dark-medium")
						.animation-step-delete
							.fa.fa-remove(v-on:click="removeStep(animationStep, $event)")
				.form-actions
					button.btn.btn-primary(type="button" @click="createStep()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Add new animation step row'}")
						i.fa.fa-plus
						span Add animation step
					button.btn.btn-dark(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen';

	import { Creative } 			from '../../services/Creative'
	import { Version } 			from '../../services/Version'
	import { Settings } 		from '../../services/Settings'
	import { Elements } 		from '../../services/Elements'
	import { Animation } 		from '../../services/Animation'

	import EditorPropertyImage	from './../Editor/Controls/EditorPropertyImage'
	import EditorPropertyText	from './../Editor/Controls/EditorPropertyText'
	import EditorPropertyVideo	from './../Editor/Controls/EditorPropertyVideo'
	import EditorPropertySpine	from './../Editor/Controls/EditorPropertySpine'
	import EditorPropertySpineOption	from './../Editor/Controls/EditorPropertySpineOption'
	import InputNumberDrag		from './../Editor/Controls/InputNumberDrag'
	import InputRange			from './../Editor/Controls/InputRange'
	import InputCoordsDrag		from './../Editor/Controls/InputCoordsDrag'
	import InputAngle			from './../Editor/Controls/InputAngle'
	import InputSelect			from './../Editor/Controls/InputSelect'
	import InputSwitch			from './../Editor/Controls/InputSwitch'
	import Select				from './../Editor/Controls/Select'

	export default {
		name: "AnimationSettings",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Element Animation Changed",
				"Animation Step Added",
				"Animation Step Changed",
				"Animation Step Removed"
			],
			events: {
				"Show Animation Settings": function(animation) {

					this.animation = animation;

					this.show();

				}
			}
		},
		components: {
			EditorPropertyImage,
			EditorPropertyText,
			EditorPropertyVideo,
			EditorPropertySpine,
			EditorPropertySpineOption,
			InputNumberDrag,
			InputRange,
			InputCoordsDrag,
			InputAngle,
			InputSelect,
			InputSwitch,
			Select
		},
		data() {

			this.Creative = Creative;
			this.Version = Version;
			this.Settings = Settings;

			this.animation = null;
			this.animationSteps = [];

			this.times = [
				{title: "1.00", description: "Absolute time (in seconds) measured from the start of the timeline", width: 200, data: {itemValue: "1.00"}},
				{title: ">", description: "The start of previous animation step", width: 200, data: {itemValue: ">"}},
				{title: "<", description: "The end of previous animation step", width: 200, data: {itemValue: "<"}},
				{title: "<+=1.0", description: "1 second past the start of the previous animation", width: 200, data: {itemValue: "<+=1.0"}},
				{title: "<-=1.0", description: "1 second before the end of the previous animation", width: 200, data: {itemValue: "<-=1.0"}}
			];

			this.properties = [];

			this.easings = _.map([["power1"], ["power2"], ["power3"], ["power4"], ["back", "(1.7)"], ["bounce"], ["circ"], ["elastic", "(1,0.3)"], ["expo"], ["sine"]], ([ease, easeParams = '']) => {
				return {title: ease, width: 200, opened: false, childs: _.map(['in', 'inOut', 'out'], mod => {
					return {title: `${mod}`, width: 50, data: {itemValue: `${ease}.${mod}${easeParams}`}}}
				)};
			});

			this.easings.push({title: 'steps', width: 200, data: {itemValue: `steps(10)`}});
			this.easings.push({title: 'none', width: 200, data: {itemValue: `none`}});

			return {
				title: '',
				count: 0
			}
		},
		methods: {
			collectData() {

				this.animation = AnimationService.AnimationsById[this.animation.id];
				this.version = Version.SelectedVersion;
				this.title = this.animation.title;
				this.element =  Elements.ElementsByHierarchy[this.animation["version_id"]][this.animation["screen_codename"]][this.animation["element_codename"]];

				let props = _.filter(_.orderBy(Metadata.ElementProperties, 'priority'), propertyParams => propertyParams.active && (!propertyParams.options.elementTypes || _.includes(propertyParams.options.elementTypes, this.element?.type)));

				let mainItem = {title: 'Main', width: 200, opened: false, childs: _.map(_.filter(props, o => o.section === 'main'), property => {
						return {..._.pick(property, ['title', 'description']), data: {itemValue: property.codename}}}
					)};

				let dimensionItem = {title: 'Dimensions', width: 200, opened: false, childs: _.map(_.filter(props, o => o.section === 'dimensions'), property => {
						return {..._.pick(property, ['title', 'description']), data: {itemValue: property.codename}}}
					)};

				let filtersItem = {title: 'Filters', width: 200, opened: false, childs: _.map(_.filter(props, o => o.section === 'filters'), property => {
						return {..._.pick(property, ['title', 'description']), data: {itemValue: property.codename}}}
					)};

				let maskItem = {title: 'Mask', width: 200, opened: false, childs: _.map(_.filter(props, o => o.section === 'mask'), property => {
						return {..._.pick(property, ['title', 'description']), data: {itemValue: property.codename}}}
					)};

				let behaviorItem = {title: 'Behavior', width: 200, opened: false, childs: _.map(_.filter(props, o => o.section === 'behavior'), property => {
						return {..._.pick(property, ['title', 'description']), data: {itemValue: property.codename}}}
					)};

				this.properties = [
					mainItem,
					dimensionItem,
					filtersItem,
					maskItem,
					behaviorItem
				];

				this.animation = Animation.AnimationsById[this.animation.id];
				this.animationSteps = Animation.AnimationStepsByHierarchy[this.animation["version_id"]]?.[this.animation["screen_codename"]]?.[this.animation["element_codename"]]?.[this.animation["codename"]] || {};

				this.animationSteps = _.orderBy(_.values(this.animationSteps), "priority");

				this.count++;

			},
			updateName() {

				Server.sendWithTimeout({
					RenameAnimation: {
						animationId: this.animation.id,
						title: this.title.trim()
					}
				}, null, 200);

			},
			setAnimationProperty(propertyName, value) {

				this.animation.props[propertyName] = value;

				this.update();

				Server.sendToServer({
					SetAnimationProperty: {
						animationId: this.animation.id,
						animationPropertyCodename: propertyName,
						animationPropertyValue: value,
					}
				});

			},
			moveUp(animationStep) {

				Server.sendToServer({
					MoveAnimationStepUp: {
						animationStepId: animationStep.id
					}
				});

			},
			moveDown(animationStep) {

				Server.sendToServer({
					MoveAnimationStepDown: {
						animationStepId: animationStep.id
					}
				});

			},
			setTime(animationStep, time, sendToServer = true) {

				animationStep.time = time;

				if (sendToServer) Server.sendToServer({
					SetAnimationStepTime: {
						animationStepId: animationStep.id,
						time: time
					}
				});

			},
			setProperty(animationStep, property, sendToServer = true) {

				//animationStep.property = property;

				if (sendToServer) Server.sendToServer({
					SetAnimationStepProperty: {
						animationStepId: animationStep.id,
						elementPropertyCodename: property
					}
				});

			},
			setValue(animationStep, value, sendToServer = true) {

				//animationStep.value = value;

				if (sendToServer) Server.sendToServer({
					SetAnimationStepValue: {
						animationStepId: animationStep.id,
						value: value
					}
				});

			},
			setDuration(animationStep, duration, sendToServer = true) {

				//animationStep.duration = duration;

				if (sendToServer) Server.sendToServer({
					SetAnimationStepDuration: {
						animationStepId: animationStep.id,
						duration: duration
					}
				});

			},
			setEase(animationStep, ease, sendToServer = true) {

				animationStep.ease = ease;

				if (sendToServer) Server.sendToServer({
					SetAnimationStepEase: {
						animationStepId: animationStep.id,
						ease: ease
					}
				});

			},
			setRelative(animationStep, relative, sendToServer = true) {

				//animationStep.options.relative = relative;

				if (sendToServer) Server.sendToServer({
					SetAnimationStepRelative: {
						animationStepId: animationStep.id,
						relative: relative
					}
				});

			},
			createStep() {

				Server.sendToSocket({
					AddAnimationStep: {
						animationId: this.animation.id
					}
				});

			},
			removeStep(animationStep, e) {

				Broadcast.call('Show Confirm', [{
					caption: 'Delete animation step',
					message: `Are you sure you want to delete animation step?`,
					confirmButtonText: '&nbsp;&nbsp;Delete step',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {
						Server.sendToSocket({
							RemoveAnimationStep: {
								animationStepId: animationStep.id
							}
						});
					}
				}]);

			}
		}
	}
</script>


<style lang="sass">

	.animation-settings
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card

			.dropdown-control
				position: relative
				border: 1px solid #23282c
				border-radius: 0.25rem
				background: #515b65
				padding-top: 0.25rem
				padding-bottom: 0.25rem
				padding-right: 2rem
				padding-left: 0.5rem
				color: #e4e7ea
				cursor: pointer
				font-size: 0.765625rem
				height: 30px

				&:hover
					border: 1px solid rgba(255, 255, 255, 0.3)
					//background: rgba(255, 255, 255, 0.1) no-repeat

				.value
					max-width: 125px
					overflow: hidden
					text-overflow: ellipsis
					white-space: nowrap
					font-size: 14px

				.drop-icon
					position: absolute
					width: 25px
					height: 30px
					right: 0
					top: 0
					color: #e4e7ea
					font-size: 14px
					cursor: pointer
					text-align: center

					&:before
						position: absolute
						top: 7px
						right: 7px
						color: rgba(255,255,255,0.2)

			.dropdown-control:hover

				.drop-icon:before
					color: rgba(255,255,255,0.8)

		.card
			width: 940px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input.title
				width: 260px
				margin-top: 5px

			select
				background-color: #515b65
				border: 1px solid #23282c

				&:focus
					outline: none
					box-shadow: none
					border: 1px solid rgba(255, 255, 255, 0.3)

			input:focus
				outline: none
				box-shadow: none
				background-color: #515b65
				border: 1px solid rgba(255, 255, 255, 0.3)

			.btn-danger, .btn-primary
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.controls-title
				padding-left: 2px
				padding-bottom: 0

			.controls.duration-scale-control
				margin-top: 5px

		.animation-steps
			display: table
			width: 100%
			//max-height: 100px
			//overflow-y: auto

			.animation-steps-header
				display: table-row
				cursor: default

				.animation-step-up
					display: table-cell
					width: 25px

				.animation-step-down
					display: table-cell
					width: 25px

				.animation-step-time
					display: table-cell
					padding: 3px 0
					//border-bottom: 1px solid rgba(0,0,0,0.3)

				.animation-step-property
					display: table-cell
					padding: 3px 0
					padding-left: 10px
					vertical-align: top
					//border-bottom: 1px solid rgba(0,0,0,0.3)

					.value
						width: 90px

				.animation-step-value
					display: table-cell
					padding: 3px 0
					padding-left: 10px
					vertical-align: top
					//border-bottom: 1px solid rgba(0,0,0,0.3)

				.animation-step-duration
					display: table-cell
					padding: 3px 0
					padding-left: 10px
					vertical-align: top
					//border-bottom: 1px solid rgba(0,0,0,0.3)

				.animation-step-ease
					display: table-cell
					padding: 3px 0
					padding-left: 10px
					vertical-align: top
					//border-bottom: 1px solid rgba(0,0,0,0.3)
					width: 150px

				.animation-step-relative
					display: table-cell
					padding: 3px 0
					padding-left: 10px
					vertical-align: top
					//border-bottom: 1px solid rgba(0,0,0,0.3)

				.animation-step-delete
					display: table-cell
					width: 25px

			.animation-step
				display: table-row

				.animation-step-up
					display: table-cell
					width: 25px
					vertical-align: top
					padding-top: 14px
					padding-right: 10px
					color: rgba(255,255,255,0.2)
					text-align: center

					.fa
						padding: 5px
						cursor: pointer
						font-size: 20px

						&:hover
							color: rgba(255,255,255,0.6)

						&.disabled
							color: rgba(255,255,255,0.05)
							cursor: default

				.animation-step-down
					display: table-cell
					width: 25px
					vertical-align: top
					padding-top: 14px
					padding-right: 10px
					color: rgba(255,255,255,0.2)
					text-align: center

					.fa
						padding: 5px
						cursor: pointer
						font-size: 20px

						&:hover
							color: rgba(255,255,255,0.6)

						&.disabled
							color: rgba(255,255,255,0.05)
							cursor: default

				.animation-step-time
					display: table-cell
					padding-top: 13px
					width: 70px

				.animation-step-property
					display: table-cell
					padding-top: 13px
					padding-left: 10px
					vertical-align: top

					.value
						width: 90px

				.animation-step-value
					display: table-cell
					padding-top: 13px
					padding-left: 10px
					vertical-align: top
					width: 250px

				.animation-step-duration
					display: table-cell
					padding-top: 13px
					padding-left: 10px
					vertical-align: top

				.animation-step-ease
					display: table-cell
					padding-top: 13px
					padding-left: 10px
					vertical-align: top

					.value
						width: 90px

				.animation-step-relative
					display: table-cell
					vertical-align: middle
					padding-top: 13px
					padding-left: 10px
					text-align: center

				.animation-step-delete
					display: table-cell
					width: 25px
					vertical-align: top
					padding-top: 16px
					padding-left: 10px
					text-align: center

					.fa
						padding: 5px
						cursor: pointer
						color: rgba(255,255,255,0.2)

						&:hover
							color: var(--danger)


		.form-group
			display: flex
			flex-direction: column
			margin-left: 40px

			&:first-child
				margin-left: 0

		.form-line
			display: flex
			flex-direction: row

		.form-actions
			margin-top: 20px

</style>

